<ion-content>

    <custom-header [class]="themeConfig.name"></custom-header>

    <div class="content-wrapper {{themeConfig.name}}"
         [ngClass]="{'subcommunity': !!themeConfig.name}">
        <div class="background-column-left"></div>

        <div class="content-centered-column">
            <div class="content-centered-row">

                <ion-grid>
                    <ion-row>
                        <ion-col size="12"
                                 size-sm="5"
                                 class="main-text">

                            <h1 [innerHtml]="'CUSTOM_MAIN_TITLE' + themeConfig.themeSuffix | translate"></h1>

                            <p [innerHtml]="'CUSTOM_MAIN_TEXT' | translate"></p>

                        </ion-col>
                        <ion-col size="12"
                                 size-sm="7"
                                 class="main-form">

                            <form (ngSubmit)="set()"
                                  #f="ngForm"
                                  novalidate>

                                <ion-list class="form">
                                    <ion-item class="ion-no-lines">
                                        <h1>{{ 'SET_PASSWORD_PASSWORD_SET' | translate}}</h1>
                                    </ion-item>

                                    <ion-item class="ion-no-lines">
                                        <p>{{ 'SET_PASSWORD_PASSWORD_PLEASE_SET' | translate }}</p>
                                    </ion-item>

                                    <ion-item class="ion-no-lines">
                                        <!-- <ion-label position="floating">{{ 'PASSWORD' | translate }}</ion-label> -->
                                        <ion-input type="password"
                                                   placeholder="{{ 'PASSWORD_PLACEHOLDER' | translate }}"
                                                   name="password"
                                                   (keyup.enter)="set()"
                                                   #password="ngModel"
                                                   [(ngModel)]="model.password"
                                                   required>
                                        </ion-input>
                                    </ion-item>
                                    <ion-item class="ion-no-lines">
                                        <!-- <ion-label position="floating">{{ 'PASSWORD_CONFIRMATION' | translate }}</ion-label> -->
                                        <ion-input type="password"
                                                   placeholder="{{ 'PASSWORD_PLACEHOLDER' | translate }}"
                                                   name="password_confirmation"
                                                   (keyup.enter)="set()"
                                                   #password_confirmation="ngModel"
                                                   [(ngModel)]="model.password_confirmation"
                                                   required>
                                        </ion-input>
                                    </ion-item>

                                    <ion-button expand="block"
                                                type="submit"
                                                [disabled]="!f.form.valid">
                                        {{ 'SET_PASSWORD_BUTTON_SET_PASSWORD' | translate }}
                                    </ion-button>

                                    <ion-item class="login ion-no-lines ion-no-padding">
                                        <div>
                                            <a class="link"
                                               [routerLink]="'/'">
                                                {{ 'LOST_PASSWORD_GOTO_LOGIN' | translate }}
                                            </a>
                                        </div>
                                    </ion-item>
                                </ion-list>
                            </form>
                            <div *ngIf="!plt.isConnected">
                                <hr class="blue" />
                                {{ 'LOGIN_APP_IS_OFFLINE' | translate }}
                            </div>

                        </ion-col>
                    </ion-row>
                </ion-grid>

            </div>
        </div>

        <div class="background-column-right"></div>

    </div>

    <ng-container *ngIf="!plt.is('cordova')">
        <div class="shape-divider"
             [ngClass]="{'subcommunity': themeConfig.name}">
            <svg viewBox="0 0 1000 300"
                 xmlns="http://www.w3.org/2000/svg"
                 preserveAspectRatio="none">
                <path class="ux-shape-fill"
                      opacity="0.15"
                      d="M0 299L-2 19.9998C153 -16.0002 308 155 413 184C515.64 212.35 562 152 645 153C725 154 787 206 874 233C939.54 253.34 975 248 1000 244.61V299H0Z"></path>
                <path class="ux-shape-fill"
                      opacity="0.3"
                      d="M0 300L-2 34C155 -9.00003 300 178 403 212C504.11 245.38 562 165 645 166C725 167 790.09 220.07 874 253C939.21 278.59 978.07 269.72 1000 263.61V300H0Z"></path>
                <path class="ux-shape-fill"
                      d="M0 300L-1 69.7099C216 56.9999 299.47 198.86 403 226C506 253 577 196 660 197C740 198 790.09 234.07 874 267C935.23 291 982 282.61 1000 277.61V300H0Z"></path>
            </svg>
        </div>
        <custom-actors></custom-actors>
        <custom-footer></custom-footer>
    </ng-container>
</ion-content>